import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border-2 border-background-200 rounded-xl text-foreground-900 font-medium text-sm hover:border-primary-300 transition-all duration-200 cursor-pointer group"
      >
        <span className="flex items-center gap-2">
          <i className="ri-grid-line text-lg text-primary-500"></i>
          Browse Product Categories
        </span>
        <i
          className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        ></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-background-50 border border-background-200/80 rounded-xl overflow-hidden z-40 animate-[fadeIn_0.15s_ease-out]">
          <div className="max-h-72 overflow-y-auto py-2">
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${cat.icon} text-base text-foreground-600`}></i>
                </div>
                <span className="whitespace-nowrap">{cat.name}</span>
                <i className="ri-external-link-line text-xs text-foreground-400 ml-auto"></i>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}